import { WineClub } from "../../contexts/wine-clubs/types";

const WineClubs: WineClub[] = [
  {
    label: "The Mofo Club",
    key: "mofo-club",
    color: "primary",
    description: "The original, most awesome wine club on the planet.",
    defaultPlan: "mofo-club|mixed|standard|2-months",
    variants: [
      {
        key: "whites",
        label: "Whites",
        price: 159.0,
        rrp: "Over $300 RRP",
        packSize: 12,
        freeShipping: true,
        preferences: [
          { label: "Standard", key: "standard" },
          { label: "No Chardonnay", key: "no-chardonnay" },
          { label: "No Sav Blanc", key: "no-sauvignon-blanc" },
        ],
      },
      {
        key: "mixed",
        label: "Mixed",
        price: 179.0,
        rrp: "Over $300 RRP",
        packSize: 12,
        freeShipping: true,
        preferences: [
          { label: "Standard", key: "standard" },
          { label: "No Sav Blanc", key: "no-sauvignon-blanc" },
          { label: "No Pinot Noir", key: "no-pinot-noir" },
        ],
      },
      {
        key: "reds",
        label: "Reds",
        price: 199.0,
        rrp: "Over $300 RRP",
        packSize: 12,
        freeShipping: true,
        preferences: [
          { label: "Standard", key: "standard" },
          { label: "No Pinot Noir", key: "no-pinot-noir" },
          { label: "No Grenache", key: "no-grenache" },
        ],
      },
    ],
    frequencies: [
      { label: "1 Month", key: "1-month" },
      { label: "2 Months", key: "2-months" },
      { label: "3 Months", key: "3-months" },
    ],
  },
  {
    label: "Black Market Club",
    key: "black-market-club",
    color: "liquidGold",
    description: "The best lineup has joined the club.",
    defaultPlan: "black-market-club|standard|standard|2-months",
    variants: [
      {
        key: "standard",
        label: "Standard",
        price: 139.0,
        rrp: "60-70% off RRP",
        packSize: 12,
        freeShipping: true,
        preferences: [{ label: "Standard", key: "standard" }],
      },
    ],
    frequencies: [
      { label: "1 Month", key: "1-month" },
      { label: "2 Months", key: "2-months" },
    ],
  },
];

export default WineClubs;
